SlideView = require("views/slide")

class SpeechBubbleView extends SlideView
  template: require("./template")

  events: ->
    "iostap .btn-done": "next"

  beforeShow: ->
    @trigger("ui", flexibleHeight: true)

  beforeHide: ->
    @trigger("ui", flexibleHeight: false)

module.exports = SpeechBubbleView
